export const environment = {
    production: false,
    // baseUrl: 'https://api.firstcompani.com/',
    baseUrl: 'https://api-dev.firstcompani.com/',
    RAZORPAY_KEY: 'rzp_test_QDRwbaPQVzD7sB',
    landingpage: 'https://dev-xyz.firstcompani.com/',
    version: '1.0.5',
  
  };